// @ts-nocheck
export class UiState {
  focusRun?: number
  showPupil = false // actually show indicators
}
